import React from 'react'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import numberFormatFunctions from '~/Classes/numberFormatFunctions'

export default function SmsSendAnalysis({ campaign, analysis, messages, hasMergeTags }) {
    let total = 0

    analysis.forEach((a) => (total += a.count))

    if (campaign.limit && Number(campaign.limit) > 0) {
        if (Number(campaign.limit) < total) total = Number(campaign.limit)
    }

    return (
        <Paper className='mar-b20'>
            <h4 className='mar-b20'>Country Breakdown</h4>
            <div className='flexSpaceBetween'>
                <div>
                    <div className='mar-b5' style={{ color: '#999' }}>
                        Country
                    </div>
                    {analysis
                        .filter((a) => a.count)
                        .map((a) => (
                            <div key={'c_' + a.country} className='text-heavy'>
                                {a.country === 'GB' ? 'United Kingdom' : a.country}
                            </div>
                        ))}
                </div>
                <div className='quickFlex' style={{ justifyContent: 'flex-end' }}>
                    <div className='mar-r20'>
                        <div className='mar-b5' style={{ color: '#999' }}>
                            Recipients
                        </div>
                        {analysis
                            .filter((a) => a.count)
                            .map((a) => (
                                <div key={'co_' + a.country} className='text-heavy text-right'>
                                    {numberFormatFunctions.formatNumber(total)}
                                </div>
                            ))}
                    </div>
                    <div>
                        <div className='mar-b5' style={{ color: '#999' }}>
                            Credits
                        </div>
                        {analysis
                            .filter((a) => a.count)
                            .map((a) => (
                                <div key={'cr_' + a.country} className='text-heavy text-right'>
                                    {numberFormatFunctions.formatNumber(total * messages)}
                                    {hasMergeTags && '*'}
                                </div>
                            ))}
                    </div>
                </div>
            </div>
            {hasMergeTags && (
                <div className='text-xsml mar-t10'>
                    *As you are using merge tags the number of credits used per send may vary
                </div>
            )}
        </Paper>
    )
}
